<template>
  <el-dialog
    title="新增角色"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="roleForm" label-width="90px" size="small">
      <!-- 角色名称 -->
      <el-form-item label="角色名称" prop="role_name">
        <el-input v-model.trim="form.role_name" placeholder="请输入角色名称" />
      </el-form-item>

      <!-- 角色编号 -->
      <el-form-item label="角色编号" prop="role_code">
        <el-input v-model.trim="form.role_code" placeholder="请输入角色编号（可选）" />
      </el-form-item>

      <!-- 显示顺序 -->
      <el-form-item label="显示顺序" prop="display_order">
        <el-input-number
          v-model="form.display_order"
          :min="0"
          :max="999"
          placeholder="排序值越小越靠前"
          style="width: 100%;"
        />
      </el-form-item>

      <!-- 状态 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.remark"
          placeholder="请输入备注信息（可选）"
        />
      </el-form-item>

      <!-- 菜单选择（树形多选） -->
      <el-form-item label="分配菜单" prop="menuIds">
        <el-tree
          ref="menuTree"
          :data="menuList"
          show-checkbox
          node-key="id"
          :props="treeProps"
          highlight-current
          default-expand-all
          :expand-on-click-node="false"
          empty-text="加载中..."
          @check-change="onMenuCheckChange"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.path" style="color: #999; font-size: 12px; margin-left: 8px;">
              {{ data.path }}
            </span>
          </span>
        </el-tree>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateRole',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,

      // 表单数据
      form: {
        role_name: null,
        role_code: null,
        display_order: 0,
        status: 0,
        remark: null,
        menuIds: [] // 选中的菜单 ID 数组
      },

      // 验证规则
      rules: {
        role_name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        menuIds: [
          { 
            required: true, 
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请至少选择一个菜单权限'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }
        ]
      },

      // 菜单树数据
      menuList: [],
      menuLoading: false,

      // el-tree 配置
      treeProps: {
        label: 'name',
        children: 'children'
      }
    };
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
      this.loadMenus();
      this.$nextTick(() => {
        this.$refs.roleForm.clearValidate();
      });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.roleForm) {
        this.$refs.roleForm.resetFields();
      }
      this.form.menuIds = [];
      this.$nextTick(() => {
        if (this.$refs.menuTree) {
          this.$refs.menuTree.setCheckedKeys([]);
        }
      });
    },

    // 加载菜单树
    loadMenus() {
      if (this.menuList.length > 0) return;

      this.menuLoading = true;
      this.$axios
        .get('/api-30216/api/roles/menus')
        .then(res => {
          const data = (res.data && res.data.data) || res.data || [];
          this.menuList = data;
        })
        .catch(err => {
          this.$message.error('加载菜单失败');
          console.error(err);
        })
        .finally(() => {
          this.menuLoading = false;
        });
    },

    // 菜单勾选变化
    onMenuCheckChange() {
      const checkedKeys = this.$refs.menuTree.getCheckedKeys();
      this.form.menuIds = checkedKeys;
    },

    // 提交表单
    submitForm() {
      this.$refs.roleForm.validate(valid => {
        if (!valid) {
          this.$message.warning('请检查表单填写');
          return;
        }

        const postData = { ...this.form };

        this.submitLoading = true;
        this.$axios
          .post('/api-30216/api/roles', postData, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [postData => JSON.stringify(postData)]
          })
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success('角色创建成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新列表
            } else {
              this.$message.error(responseData.message || '创建失败');
            }
          })
          .catch(err => {
            let msg = '创建角色失败';
            if (err.response && err.response.data && err.response.data.message) {
              msg = err.response.data.message;
            } else if (err.message) {
              msg = err.message;
            }
            this.$message.error(msg);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>